import React, { useMemo } from 'react';
import { at } from 'lodash';
import { useField, useFormikContext } from 'formik';
import { Checkbox, FormControl, FormControlLabel, FormHelperText } from '@mui/material';


function CheckboxField(props) {
  const { 
    label, 
    disabledDepends, 
    disabledValidationValue, 
    disabledDependsOnFields, 
    labelFontWeight,
    ...rest 
  } = props;
  const [field, meta, helper] = useField(props);
  const { setValue } = helper;

  const { values } = useFormikContext();

  function _renderHelperText() {
    const [touched, error] = at(meta, 'touched', 'error');
    if (touched && error) {
      return <FormHelperText error>{error}</FormHelperText>;
    }
  }

  const isDisabled = useMemo(() => {
    if (props.disabled) {
      return true;
    }

    if (Array.isArray(disabledDependsOnFields) && disabledDependsOnFields.length > 0) {
      for (const dep of disabledDependsOnFields) {
        if (dep.disabledDepends && dep.disabledValidationValue !== undefined) {
          const dependsKey = dep.disabledDepends.includes('.') ? dep.disabledDepends.split('.') : dep.disabledDepends;
          const dependsValue = dep.disabledDepends.includes('.')
            ? values[dependsKey[0]]?.[dependsKey[1]]
            : values[dependsKey];
          if (dependsValue === dep.disabledValidationValue) {
            return true;
          }
        }
      }
    } else if (disabledDepends && disabledValidationValue !== undefined) {
      const dependsKey = disabledDepends.includes('.') ? disabledDepends.split('.') : disabledDepends;
      const dependsValue = disabledDepends?.includes('.')
        ? values[dependsKey[0]]?.[dependsKey[1]]
        : values[dependsKey];
      if (dependsValue === disabledValidationValue) {
        return true;
      }
    }
    return false;
  }, [values, disabledDepends, disabledValidationValue, props.disabled, disabledDependsOnFields]);

  function _onChange(e) {
    setValue(e.target.checked);
  }

  return (
    <FormControl disabled={isDisabled} {...rest}>
      <FormControlLabel
        value={field.value}
        checked={field.value}
        control={<Checkbox {...field} onChange={_onChange} disabled={isDisabled} />}
        label={label}
      />
      {_renderHelperText()}
    </FormControl>
  );
}

export default React.memo(CheckboxField);
